export interface Project {
  id: string;
  title: string;
  category: string;
  location: string;
  year: string;
  area: string;
  client: string;
  materials: string[];
  cover: string;
  summary: string;
  description: string;
}

export const projectCategories = [
  "전체",
  "주거 공간",
  "상업 공간",
  "호텔·리조트",
  "오피스",
];

export const projects: Project[] = [
  {
    id: "gangnam-residence",
    title: "강남 프라이빗 레지던스",
    category: "주거 공간",
    location: "서울 강남구",
    year: "2026",
    area: "198㎡",
    client: "개인 고객",
    materials: ["스타튜어리오", "뉴 카라라 퀄츠"],
    cover:
      "https://readdy.ai/api/search-image?query=luxury%20modern%20apartment%20kitchen%20interior%20with%20white%20marble%20island%20countertop%2C%20warm%20wood%20cabinets%2C%20large%20windows%20with%20soft%20daylight%2C%20minimal%20high%20end%20residential%20design%2C%20architectural%20photography&width=1200&height=800&seq=stone-proj-01&orientation=landscape",
    summary: "대리석 아일랜드가 중심이 된 프리미엄 주거 공간",
    description:
      "주방과 거실이 하나로 이어지는 개방형 구조에 스타튜어리오 아일랜드 상판을 적용했습니다. 자연광이 드는 낮에는 결의 흐름이 살아나고, 조명을 켠 저녁에는 은은한 광택이 공간의 중심을 만들어 줍니다. 수납 상판에는 관리가 쉬운 엔지니어드 쿼츠를 사용해 실용성까지 챙겼습니다.",
  },
  {
    id: "seongsu-stonehouse",
    title: "성수동 카페 스톤하우스",
    category: "상업 공간",
    location: "서울 성동구",
    year: "2025",
    area: "156㎡",
    client: "스톤하우스",
    materials: ["테라조 그레이", "임페리얼 그레이"],
    cover:
      "https://readdy.ai/api/search-image?query=stylish%20industrial%20cafe%20interior%20with%20terrazzo%20floor%20and%20stone%20bar%20counter%2C%20warm%20ambient%20lighting%2C%20exposed%20ceiling%2C%20modern%20retail%20design%2C%20architectural%20interior%20photography&width=1200&height=800&seq=stone-proj-02&orientation=landscape",
    summary: "테라조 바닥과 석재 바 카운터가 어우러진 카페",
    description:
      "노출 천장과 콘크리트 벽체 사이로 테라조 그레이 바닥을 깔아 거친 질감과 매끈한 표면의 대비를 만들었습니다. 바 카운터는 화강석으로 시공해 잦은 사용에도 흠집 없이 견고하게 유지됩니다.",
  },
  {
    id: "haeundae-hotel-lobby",
    title: "해운대 호텔 로비",
    category: "호텔·리조트",
    location: "부산 해운대구",
    year: "2025",
    area: "420㎡",
    client: "오션뷰 호텔",
    materials: ["칼라카타 골드", "실버 트래버틴"],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20grand%20hotel%20lobby%20interior%20with%20marble%20flooring%20and%20stone%20feature%20wall%2C%20warm%20golden%20lighting%2C%20high%20ceiling%2C%20luxury%20hospitality%20design%2C%20wide%20architectural%20photography&width=1200&height=800&seq=stone-proj-03&orientation=landscape",
    summary: "골드 결 대리석으로 완성한 럭셔리 호텔 로비",
    description:
      "체크인 데스크 후면 벽체에 칼라카타 골드를 북매치 시공해 로비 전체의 시선을 집중시켰습니다. 바닥은 실버 트래버틴으로 차분하게 마감해 대비를 이루고, 넓은 공간에서도 이음매 없이 정돈된 인상을 줍니다.",
  },
  {
    id: "cheongdam-beauty-salon",
    title: "청담 뷰티 살롱",
    category: "상업 공간",
    location: "서울 강남구",
    year: "2025",
    area: "98㎡",
    client: "뷰티 살롱 에이블",
    materials: ["칼라카타 골드", "테라조 화이트"],
    cover:
      "https://readdy.ai/api/search-image?query=chic%20beauty%20salon%20interior%20with%20marble%20reception%20desk%20and%20soft%20cream%20walls%2C%20warm%20indirect%20lighting%2C%20mirrors%20and%20elegant%20furniture%2C%20high%20end%20commercial%20interior%20photography&width=1200&height=800&seq=stone-proj-04&orientation=landscape",
    summary: "골드 대리석 리셉션으로 고급감을 전한 뷰티 공간",
    description:
      "입구에서 가장 먼저 눈에 들어오는 리셉션 데스크에 골드 결 대리석을 사용해 브랜드의 고급스러운 이미지를 전달했습니다. 시술 공간 바닥은 밝은 테라조로 마감해 위생적이고 청결한 인상을 강조했습니다.",
  },
  {
    id: "pangyo-office-lobby",
    title: "판교 오피스 로비",
    category: "오피스",
    location: "경기 성남시",
    year: "2024",
    area: "310㎡",
    client: "판교 테크노밸리",
    materials: ["임페리얼 그레이", "세라믹 마블 그레이"],
    cover:
      "https://readdy.ai/api/search-image?query=contemporary%20corporate%20office%20lobby%20with%20grey%20stone%20floor%20and%20minimal%20reception%20area%2C%20bright%20natural%20light%2C%20glass%20facade%2C%20professional%20architectural%20interior%20photography&width=1200&height=800&seq=stone-proj-05&orientation=landscape",
    summary: "그레이 석재로 정돈한 모던 오피스 로비",
    description:
      "기업 이미지에 맞춰 무채색 석재를 중심으로 로비를 구성했습니다. 바닥에는 내구성이 뛰어난 화강석을, 엘리베이터 홀 벽면에는 대형 세라믹을 적용해 관리 부담을 줄이면서도 세련된 인상을 유지했습니다.",
  },
  {
    id: "jeju-resort-bath",
    title: "제주 리조트 스파 욕실",
    category: "호텔·리조트",
    location: "제주 서귀포시",
    year: "2025",
    area: "76㎡",
    client: "제주 오션 리조트",
    materials: ["트래버틴 클래식", "세라믹 베이지"],
    cover:
      "https://readdy.ai/api/search-image?query=serene%20spa%20bathroom%20interior%20with%20beige%20travertine%20walls%20and%20freestanding%20stone%20bathtub%2C%20soft%20warm%20lighting%2C%20natural%20textures%2C%20luxury%20resort%20design%2C%20interior%20photography&width=1200&height=800&seq=stone-proj-06&orientation=landscape",
    summary: "트래버틴으로 완성한 자연 친화적 스파 욕실",
    description:
      "따뜻한 베이지 트래버틴으로 벽과 바닥을 마감해 자연 속에 있는 듯한 편안함을 전했습니다. 미끄럼 저항이 우수해 물기를 자주 접하는 스파 공간에서도 안전하게 사용할 수 있습니다.",
  },
  {
    id: "hannam-penthouse",
    title: "한남동 펜트하우스",
    category: "주거 공간",
    location: "서울 용산구",
    year: "2024",
    area: "264㎡",
    client: "개인 고객",
    materials: ["네로 마퀴나", "뉴 카라라 퀄츠"],
    cover:
      "https://readdy.ai/api/search-image?query=modern%20penthouse%20living%20room%20interior%20with%20black%20marble%20feature%20wall%20and%20city%20view%20windows%2C%20warm%20elegant%20lighting%2C%20minimal%20luxury%20furniture%2C%20high%20end%20residential%20photography&width=1200&height=800&seq=stone-proj-07&orientation=landscape",
    summary: "블랙 대리석 포인트 벽이 돋보이는 펜트하우스",
    description:
      "거실 중앙에 네로 마퀴나를 활용한 포인트 벽을 세워 공간에 또렷한 중심을 만들었습니다. 밝은 퀄츠 상판과 조합해 무게감과 경쾌함이 공존하는 현대적인 거실을 완성했습니다.",
  },
  {
    id: "daechi-remodeling",
    title: "대치동 아파트 리모델링",
    category: "주거 공간",
    location: "서울 강남구",
    year: "2024",
    area: "132㎡",
    client: "개인 고객",
    materials: ["뉴 카라라 퀄츠", "세라믹 베이지"],
    cover:
      "https://readdy.ai/api/search-image?query=bright%20renovated%20family%20apartment%20kitchen%20and%20dining%20area%20with%20white%20quartz%20countertop%2C%20warm%20wood%20floor%2C%20soft%20daylight%2C%20clean%20minimal%20interior%20design%20photography&width=1200&height=800&seq=stone-proj-08&orientation=landscape",
    summary: "실용성과 밝은 분위기를 모두 챙긴 리모델링",
    description:
      "관리가 어려운 기존 천연석 상판을 흡수율이 낮은 엔지니어드 쿼츠로 교체했습니다. 바닥은 베이지 세라믹으로 마감해 아이와 반려동물이 있는 가정에서도 편안하게 사용할 수 있도록 했습니다.",
  },
];